/* 🤖 this file was generated by svg-to-ts */
export const matIconTrendingDown: {
  name: 'trending-down';
  data: string;
} = {
  name: 'trending-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"/></svg>`
};
